import "../usaj-design-system/modal-wrapper"
'use strict';

(function ($) {
    $.jobsIdleTimeout = function (options) {
        var defaults = {
            title: 'Auto Logout',
            message: 'Your USAJOBS session will expire due to inactivity in eight minutes.  Any unsaved data will be lost if you allow the session to expire.  Click the button below to continue your session.',
            keepAliveButton: 'Stay signed in',
            keepAliveUrl: '',
            ajaxData: '',
            redirUrl: protocol + '//' + hostName + '/Account/LogOff',
            logoutButton: 'Sign out',
            logoutUrl: protocol + '//' + hostName + '/Account/LogOff',
            warnAfter: 1200000,  // 20 minutes
            redirAfter: 1200000,  // 20 minutes
            keepAliveInterval: 120000, // 2 minutes
            heartbeatInterval: 1000,
            noconfirm: 10000,
            keepAlive: false,
            onWarn: false,
            onRedir: false,
            clickReset: true,
            keyReset: true,
            key_press_threshold: 10,
            key_press_time_period: 30000
        };

        var opt = defaults;
        var sessionElapsed = 0;
        var sessionStart = 0;
        var heartbeatTimer;
        var lastKeepAliveReq = 0;
        var firstTime = true;
        var doReset = false;
        var confDlg = false;
        var lastKeyPress = 0;
        var keyPressCount = 0;

        // extend user-set options over defaults
        if (options) {
            opt = $.extend(defaults, options);
        }

        // some error handling if options are miss-configured
        if (opt.warnAfter >= opt.redirAfter) {
            // for IE8 and earlier
            if (typeof console !== "undefined" || typeof console.error !== "undefined") {
                console.error('idleTimeout plugin is miss-configured. Option "redirAfter" must be equal or greater than "warnAfter".');
            }
            return false;
        }

        $('#sessionTimeout-dialog-logout').on('click', function () {
            redirect();
        });

        $('#sessionTimeout-dialog-keepalive').on('click', function () {
            // restart session timer
            $('#sessionTimeout-dialog').usaj_modal_close();
            doReset = true;
            resetSessionTimer();
            doReset = false;
            confDlg = false;
        });

        function keepAlive() {
            lastKeepAliveReq = getCurrentTime();
        }

        function doHeartbeat() {
            var curr = getCurrentTime();
            sessionElapsed = curr - sessionStart;

            if (sessionElapsed > opt.redirAfter) {
                redirect();
            } else if (sessionElapsed > opt.warnAfter && !confDlg) {
                showWarning();
                confDlg = true;
            }
        }

        function showWarning() {
            $('#sessionTimeout-dialog').usaj_modal_open();
        }

        function keyPressCheck() {
            var diff = getCurrentTime() - lastKeyPress;
            if (keyPressCount >= opt.key_press_threshold || diff > opt.key_press_time_period) {
                resetSessionTimer();
                keyPressCount = 0;
            } else {
                keyPressCount++;
            }
            lastKeyPress = getCurrentTime();
        }

        function clickCheck() {
            resetSessionTimer();
        }

        function redirect() {
            if (opt.redirUrl) {
                Basil.sessionStorage.remove("userObject");
                clearInterval(heartbeatTimer);
                $.get(opt.redirUrl);
                window.localStorage.setItem("usaj-l", false);
                window.location.href = opt.redirUrl;
            }
        }

        function getCurrentTime() {
            return new Date().getTime();
        }

        function resetSessionTimer() {
            var sinceKA = getCurrentTime() - lastKeepAliveReq;

            if (sinceKA > opt.keepAliveInterval || firstTime || doReset) {
                sessionStart = getCurrentTime();
                sessionElapsed = 0;
                if (!firstTime) {
                    keepAlive();
                }
                firstTime = false;
            }
        }

        function initHeartbeat() {
            resetSessionTimer();
            heartbeatTimer = setInterval(doHeartbeat, opt.heartbeatInterval);
        }

        if (opt.keyReset) {
            $(document).on("keypress", keyPressCheck);
        }
        if (opt.clickReset) {
            $(document).on("click", clickCheck);
            $(document).on("touchend", clickCheck);
            $(document).on("touchmove", clickCheck);
        }

        initHeartbeat();
    }
})($);
